import Node from './node';

export default class Goto extends Node {
  clone() {
    return new Goto(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
